import { useEffect, useState } from 'react';
import { historyError, salesHistoryApi } from './api';
import type { SalesPeriod, SalesReport } from './types';

// Key the state as well as the request: old data must never enable a mutation
// for a newly selected department/period, even before its effect runs.
export function useReport(period: SalesPeriod | null, revision: number) {
  const request = period ? JSON.stringify(period) : '';
  const key = `${request}:${revision}`;
  const [state, setState] = useState<{ key: string; data: SalesReport | null; error: string; loading: boolean }>({
    key: '', data: null, error: '', loading: false,
  });
  useEffect(() => {
    if (!request) return;
    const controller = new AbortController();
    setState({ key, data: null, error: '', loading: true });
    salesHistoryApi.report(JSON.parse(request), controller.signal).then(data => {
      if (!controller.signal.aborted) setState({ key, data, error: '', loading: false });
    }).catch(error => {
      if (!controller.signal.aborted) setState({ key, data: null, error: historyError(error), loading: false });
    });
    return () => controller.abort();
  }, [request, key]);
  const current = state.key === key;
  return {
    data: current ? state.data : null,
    error: current ? state.error : '',
    loading: !!request && (!current || state.loading),
  };
}
